export default __webpack_public_path__ + "static/media/V220_RoHS.e8584d06.pdf";